import { render, staticRenderFns } from "./LifeTimeWarrantyTab.vue?vue&type=template&id=834e61d0"
import script from "./LifeTimeWarrantyTab.vue?vue&type=script&lang=js"
export * from "./LifeTimeWarrantyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports